export default "__VITE_ASSET__N3XKFR6d__"